require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./dallas-pd-naloxone-deployment.json") })
        }
      }, "path---dallas-pd-naloxone-deployment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---dallas-pd-naloxone-deployment!./.cache/json/dallas-pd-naloxone-deployment.json
// module id = 871
// module chunks = 231608221292675